// extracted by mini-css-extract-plugin
export default {"root":"PermalinkPopover-root-9096b504ebd1bcff70c0a10d0816afa2"};